import { ImportPage } from '@/pages/import/ImportPage';
import { LibraryPage } from '@/pages/library/LibraryPage';
import { PlayerPage } from '@/pages/player/PlayerPage';
import { useScreenStore } from '@/state/screenStore';

/** "/": the library, the analysis progress or the player, swapped in place (ADR 0007). */
export function HomePage() {
  const screen = useScreenStore((s) => s.screen);
  if (screen === 'import') return <ImportPage />;
  if (screen === 'player') return <PlayerPage />;
  return <LibraryPage />;
}
